import { useTrackEvent as _useTrackEvent } from "@microsoft/applicationinsights-react-js";
import { AIReactPlugin } from "../insights";
import type { TRACK_EVENT_TYPE, TRACK_EVENTS } from "./types";

export type TrackEvent<T extends keyof typeof TRACK_EVENTS> = {
	eventName: T;
	data?: TRACK_EVENT_TYPE[T];
};

const useTrackEvent = <T extends keyof typeof TRACK_EVENTS>(
	props: TrackEvent<T>,
) => {
	const track = _useTrackEvent(
		AIReactPlugin,
		props.eventName,
		props.data,
		false,
	);
	return track;
};

export default useTrackEvent;
